import { ConfirmModal } from '@components/ConfirmModalV2'
import { ExportButtonProps } from './interface'

export function ExportButton({
  isOpenConfirmModal,
  isLoading,
  exportFile,
  closeConfirmModal,
}: ExportButtonProps) {
  return (
    <>
      <button
        className='bg-secondary dark:bg-purple h-[40px] w-[87px] text-center rounded-[20px] text-[14px] text-white dark:text-white-2 font-mitr font-medium disabled:cursor-not-allowed'
        type='button'
        onClick={exportFile}
        disabled={isLoading}
      >
        {isLoading ? (
          <div className='w-[20px] h-[20px] mx-auto'>
            <div className='h-full w-full rounded-full border-2 border-white dark:border-purple border-b-transparent animate-spin' />
          </div>
        ) : (
          'Export'
        )}
      </button>
      <ConfirmModal
        isOpen={isOpenConfirmModal}
        textConfirm='รับทราบ'
        onConfirm={closeConfirmModal}
      >
        <p className='mb-[20px] font-mitr text-center text-[24px] text-secondary dark:text-white-2 font-medium px-[20px]'>
          ช่วงเวลาที่ Export ข้อมูลได้ สูงสุดอยู่ที่ช่วงเวลา 1 เดือน
        </p>
      </ConfirmModal>
    </>
  )
}
